module.exports = __webpack_public_path__ + "img/3rd-party-Homepage.e7dcd8f.png";